export const PUBLISH_STATUS_DRAFT = 'draft';
export const PUBLISH_STATUS_SCHEDULED = 'scheduled';
export const PUBLISH_STATUS_PUBLISHED = 'published';
export const PUBLISH_STATUS_DISABLED = 'disabled';

export const TICKET_SALE_DURATION_TYPE_DURATION = 'duration';
export const TICKET_SALE_DURATION_TYPE_BEFORE_SLOT_START = 'days_before_slot_starts';

export const TAB_OFFLINE_EVENT_INTRODUCTION = 'event_introduction';
export const TAB_OFFLINE_EVENT_INFORMATION = 'event_information';
export const TAB_OFFLINE_EVENT_CONSIDERATIONS = 'event_considerations';

/**
 * 活動分頁 → i18n key 的明確 mapping。
 *
 * 不寫成 t(`training:course:offline_event:${tab}`)：那等於宣告 offline_event 底下 70 個 key 都可能被動態取用，
 * 之後沒有人能安全刪改。列成 mapping 之後值域一眼看得完，也 grep 得到。
 */
export const EVENT_TAB_I18N_KEYS = {
	[TAB_OFFLINE_EVENT_INTRODUCTION]: 'training:course:offline_event:event_introduction',
	[TAB_OFFLINE_EVENT_INFORMATION]: 'training:course:offline_event:event_information',
	[TAB_OFFLINE_EVENT_CONSIDERATIONS]: 'training:course:offline_event:event_considerations',
} as const;
export const OFFLINE_EVENT_DROPDOWN_ANCHOR = 'OFFLINE_EVENT_DROPDOWN_ANCHOR';

export const DEFAULT_SLOT_TYPE = '';
export const DEFAULT_TICKET_TYPE = '';
export const DEFAULT_TICKET_NUMBER = 0;

export const INFO_STATUS_ACTIVITY_COUNTDOWN = 'activityCountdown';
export const INFO_STATUS_ON_SALE_COUNTDOWN = 'onSaleCountdown';
export const INFO_STATUS_SOLD_OUT_COUNTDOWN = 'soldOut';
export const INFO_STATUS_IS_OVER = 'isOver';
